export class PortalError extends Error {
    messages: string[]

    constructor(message: string | string[]) {
        if (typeof (message) === 'string') {
            super(message)
            this.messages = [message]
        } else {
            super(message[0])
            this.messages = [...message]
        }
        this.name = 'PortalError'
    }
}